module.exports = __webpack_public_path__ + "static/media/queplanta-icon.64c5d49c.svg";